import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import FileUploadTemplateComponent from "@screens/common/file-upload/file-upload-template";
import { getFileUploadInputs } from "@screens/common/file-upload/file-upload.modal";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { readFile } from "../menu-items-list/menu-items-list.component.service";
import {
  breadCrumbs,
  menuUrl,
} from "../menu-items-list/model/menu-items-list.constants";

const {
  FILE_UPLOAD_ALERT: { FILE_UPLOAD_ALERT },
  ALERT_TYPES: { SUCCESS },
} = MESSAGES;

const MenuItemsFileUploadComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const formBreadCrumb = [
    ...breadCrumbs,
    { name: "File Upload ", menu_url: "system/menu-items/upload" },
  ];
  console.log({ formBreadCrumb });
  const handleFormSubmit = async ({ values, errors }) => {
    console.log({ values, errors });

    if (errors.length > 0) {
      alert("file is mandatory");
      return;
    }

    let payload = {};

    for (let i = 0; i < values.length; i++) {
      payload[values[i].name] = values[i].value;
    }

    console.log({ payload });
    const response = await readFile(payload);
    if (response.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: FILE_UPLOAD_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      alert(response.message);
    }
  };

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const templateModal = {
    formTriggers,
    formInputs: getFileUploadInputs({}),
    formBreadCrumb,
  };

  const templateEvents = {
    handleTriggerClick,
    handleFormSubmit,
    handleBackClick,
  };

  return menuAccess ? (
    <FileUploadTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default MenuItemsFileUploadComponent;
